var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeadFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 121.669 121.669",
    style: {
      enableBackground: "new 0 0 121.669 121.669"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.835,121.669c-33.544,0-60.834-27.29-60.834-60.835C0.001,27.29,27.291,0,60.835,0s60.834,27.29,60.834,60.834 C121.669,94.379,94.379,121.669,60.835,121.669z M60.835,6C30.6,6,6.001,30.599,6.001,60.834c0,30.236,24.599,54.835,54.834,54.835 s54.834-24.599,54.834-54.835C115.669,30.599,91.071,6,60.835,6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.844,97.437h-6c0-5.642-5.477-10.231-12.208-10.231s-12.208,4.59-12.208,10.231h-6c0-8.95,8.168-16.231,18.208-16.231 S78.844,88.486,78.844,97.437z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.363,45.285 94.119,41.042 88.006,47.155 81.892,41.042 77.65,45.285 83.763,51.398 77.65,57.512 81.892,61.755 88.006,55.642 94.119,61.755 98.363,57.512 92.249,51.398  "
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "43.622,45.285 39.379,41.042 33.266,47.155 27.151,41.042 22.908,45.285 29.022,51.398 22.908,57.512 27.151,61.755 33.266,55.642 39.379,61.755 43.622,57.512 37.509,51.398  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeadFace);
export default __webpack_public_path__ + "static/media/deadFace.0024fc012da024a9c423e6c2ecdaf242.svg";
export { ForwardRef as ReactComponent };